import { Component } from "../components/index"
import { qsa, qs } from "../utils/index"

export default class HeroProduct extends Component {
  constructor(obj) {
    super(obj)

    this.review = qs(".product-review")
    this.widget = qs(".jdgm-widget", this.review)
    this.stars = qsa(".icon-star", this.review)
    this.data = qs(".jdgm-prev-badge", this.review)
    this.count = qs(".review-count", this.review)

    this.init()
  }

  setReviews() {
    const stars = this.data?.getAttribute("data-average-rating")
    const reviews = this.data?.getAttribute("data-number-of-reviews")
    const roundedStars = Math.ceil(stars)

    this.stars.forEach((star, index) => {
      if (index < roundedStars) {
        star.classList.add("one-star")
      } else {
        star.classList.add("no-star")
      }
    })

    if (reviews) {
      this.count.innerText = `(${reviews})`
    }
  }

  init() {
    this.setReviews()
  }
}
